import { Controller } from "@hotwired/stimulus"

// Shows a Bootstrap toast for flash messages and auto-dismisses it.
export default class extends Controller {
  static values = { delay: { type: Number, default: 8000 } }

  connect() {
    this.toast = new window.bootstrap.Toast(this.element, { delay: this.delayValue })
    this.toast.show()
  }

  disconnect() {
    if (this.toast) this.toast.dispose()
  }
}
